<template>
    <div id="lern-hub">
        <div class="lernButtonBereich">
            <button class="lernButton" v-if="this.poppenhausen" @click="$router.push('/leistungspruefung-wasser/'+this.routeParams)">
                <h1>Leistungsprüfung Wasser</h1>
            </button>
            <button class="lernButton" @click="$router.push('/mta2-praxis/'+this.routeParams)">
                <h1>Modulare Truppausbildung</h1>
            </button>
            <button class="lernButton" v-for="quiz in this.quize" :key="quiz.quizID">
                <div @click="$router.push('/quiz/'+this.routeParams + '/:' + quiz.quizID)">
                    <h1>{{quiz.name}}</h1>    
                </div>       
                <button v-if="aenderungsmodus" @click="lernobjektAendern(quiz)" class="fa aenderungsButtons">&#xf044;</button>
                <button v-if="aenderungsmodus" @click="lernobjektLoeschen(quiz)" class="fa aenderungsButtons buttonDelete">&#xf1f8;</button>
            </button>
            <button id="gw-l2" v-if="this.poppenhausen" class="lernButton" @click="$router.push('/gwl-2/'+this.routeParams)">
                <h1>GW-Logistik</h1>
            </button>
            <button id="waldbrand" class="lernButton" @click="$router.push('/waldbrand/'+this.routeParams)">
                <h1>Vegetationsbrände</h1>
            </button>
            <button id="atemschutz" v-if="this.poppenhausen" class="lernButton" @click="$router.push('/atemschutz/'+this.routeParams)">
                <h1>Atemschutz</h1>
            </button>
            <button id="lp-thl-infos" v-if="this.poppenhausen" class="lernButton" @click="$router.push('/lp-thl-infos/'+this.routeParams)">
                <h1>LP THL Lernstoff</h1>
            </button>
            <button class="lernButton" v-if="this.poppenhausen" @click="$router.push('/leistungspruefung-thl/'+this.routeParams)">
                <h1>LP THL Fahrzeugkunde</h1>
            </button>
            <button class="lernButton" v-if="this.poppenhausen" @click="$router.push('/lpthl-truppaufgabe/'+this.routeParams)">
                <h1>LP THL Truppaufgaben</h1>
            </button>
            <button class="lernButton" v-if="this.poppenhausen" @click="$router.push('/lp-thl-sprueche/'+this.routeParams)">
                <h1>LP THL Sprüche</h1>
            </button>
        </div>

        <br><button v-if="aenderungsmodus" class="plus-button" @click="this.neuesQuiz()">+</button>

        <button v-if="this.settingsAvailable" class="Settings fa" @click="this.settings = !this.settings"><h1>&#xf013;</h1></button>

        <span id="settings" v-if="settings">
            <p>Admin:</p>
            <hr>
            <button class="menuButton" @click="this.aenderungsmodus = !this.aenderungsmodus; this.settings = false"><span>Änderungsmodus</span><span class="fa">&#xf105;</span></button>
        </span>
        <div id="menuBackground" v-if="settings" @click="this.settings = !this.settings"></div>
    </div>
</template>

<script>
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'
import axios from 'axios';
import Swal from 'sweetalert2'
import {Benutzer} from '@/backend_controller/benutzer.js';

export default {
    name: 'LernView',
    components: {
        Header,
        Footer
    },
    data() {
        return{
            routeParams:String,
            quize: [],
            settingsAvailable: false,
            settings: false,
            aenderungsmodus: false,
            poppenhausen: false
        }
    },
    methods: {
        async getQuize() {
            var konvKey = this.$route.params.id.replace(":", "");
            try {
                const response = await axios.get(
                'https://feuerwehr-server.org:5000/quiz',
                { params: { konvKey: konvKey } }
                );
                console.log(response.data);
                return response.data;
            } catch (err) {
                console.log(err);
                return false;
            }
        },
        async lernobjektAendern(lernObj){
            if((lernObj.feuerwehrID == null || lernObj.feuerwehrID == "") && this.$route.params.id.replace(":", "") != "AKSDHGLalsghla9126589"){
                Swal.fire("Keine Berechtigung zur Bearbeitung allgemeiner Lernobjekte", "", "error");
            } else{
                await this.lernobjektNameAendern(lernObj)
            }
        },
        async lernobjektLoeschen(lernObj){
            await Swal.fire({
                title: lernObj.name + " dauerhaft löschen?",
                showDenyButton: true,
                //showCancelButton: true,
                confirmButtonText: "Löschen",
                denyButtonText: `Nicht Löschen`
            }).then((result) => {
            /* Read more about isConfirmed, isDenied below */
            if (result.isConfirmed) {
                if((lernObj.feuerwehrID == null || lernObj.feuerwehrID == "") && this.$route.params.id.replace(":", "") != "AKSDHGLalsghla9126589"){
                    Swal.fire("Keine Berechtigung zur Löschung allgemeiner Lernobjekte", "", "error");
                } else{
                    console.log("loeschen");
                    if(lernObj.quizID != null && lernObj.quizID != ""){
                        this.quizLoeschen(lernObj);
                    }
                }
                //this.deleteUser();
                //Swal.fire("Hydrant erfolgreich gelöscht", "", "success");
            } else if (result.isDenied) {
                //Swal.fire("Changes are not saved", "", "info");
            }
            });
        },
        async quizLoeschen(quiz){
            try{
                await axios.delete(
                    'https://feuerwehr-server.org:5000/deleteQuiz',
                    { params: { quizID: quiz.quizID } }
                );
                this.quize = await this.getQuize();
            } catch (err){
                console.log(err);
            };
        },
        async lernobjektNameAendern(lernObj) {
            var html = "";
            html += `<input style="width: 100%" id="name" maxLength="20" class="swal2-input" placeholder="Bezeichnung" value="` + lernObj.name + `" style="margin-left:0 !important; margin-right: 0 !important; width: 100% !important">`;

            const { value: formValues } = await Swal.fire({
                title: "Bezeichnung ändern",
                html: html,
                focusConfirm: false,
                preConfirm: () => {
                    const name = document.getElementById("name").value;
                    return { name };
                }
            });

            if (formValues) {
                const name = formValues.name;
                try{
                    if(lernObj.quizID != null && lernObj.quizID != ""){
                        this.updateQuiz(lernObj.quizID, name);
                    }
                }catch(err){

                }
            }
        },
        async updateQuiz(quizID, name){
            const quizData = {
                name: name,
                quizID: quizID,
            }

            try {
                const response = await axios.put('https://feuerwehr-server.org:5000/updateQuiz', quizData);
                Swal.fire("Änderung erfolgreich gespeichert", "", "success");
                this.quize = await this.getQuize();
                return true;
            } catch (err) {
                console.error(err);
                Swal.fire("Ändern des Quiz-Namen fehlgeschlagen", "", "error");
                return false;
            }
        },
        async neuesQuiz(){
            var html = "";
            html += `<select id="lernobjekt" class="swal2-select" style="margin-left:0 !important; margin-right: 0 !important; width: 100% !important">`;
            html += `<option value="1" selected>Quiz</option>`
            html += `<option value="2">Fahrzeugkunde</option>`
            html += `</select>`;
            html += `<input id="name" maxLength="20" class="swal2-input" placeholder="Bezeichnung" style="margin-left:0 !important; margin-right: 0 !important width: 100% !important">`;

            const { value: formValues } = await Swal.fire({
                title: "Lernobjekt anlegen",
                html: html,
                focusConfirm: false,
                preConfirm: () => {
                    const lernobjekt = document.getElementById("lernobjekt").value;
                    const name = document.getElementById("name").value;
                    return { name, lernobjekt };
                }
            });

            if (formValues) {
                const lernobjekt = formValues.lernobjekt;
                const name = formValues.name;
                if(lernobjekt == "1"){
                    this.createQuiz(name)
                } else if(lernobjekt == "2"){
                    this.createFahrzeugkunde(name)
                }
            }
        },
        createQuiz(name){

        },
        createFahrzeugkunde(name){

        },
        async checkFWPoppenhausen(){
            let benutzer = await this.getBenutzer();
            if(benutzer != undefined && benutzer.feuerwehrID == '1'){
                console.log("FW Poppenhausen");
                return true;
            } else{
                //document.getElementById('gw-l2').style.display = 'none';
                return false;
            }
        },
        async getBenutzer() {
            const response = await Benutzer.getSingleWithKonvKey(this.$route.params.id.replace(":", ""));

            if(response == false){
                return false;
            } else{
                return response;
            }
        },
    },
    async created(){
        this.routeParams = await this.$route.params.id;
        this.quize = await this.getQuize();
        if(this.$route.params.id == ':AKSDHGLalsghla9126589'){
            this.settingsAvailable = true;
        }
        this.poppenhausen = await this.checkFWPoppenhausen();
    }
}
</script>

<style lang="scss">
#lern-hub{
    display: block !important;
    position:absolute !important;
    height:auto !important;
    bottom:0 !important;
    top:0 !important;
    left:0 !important;
    right:0 !important;
    margin-top: 4.5rem !important;
    margin-bottom: 4.5rem !important;
    margin-top: 4.5rem;
    height: 72vh;
    overflow-y: scroll;

    .plus-button{
        margin-top: 0.4rem;
        padding: 0.2rem !important;
        width: 3.8rem !important;
        height: 3.8rem !important;
        line-height: 0;
        font-size: 3.6rem;
        color: white;
        background-color: blue;
        border-radius: 0.5rem;
        font-weight: bold;
    }

    .lernButton{
        width: 90%;
        //max-width: 17rem;
        max-width: 30rem;
        margin-top: 0.3rem;
        background-color: white;
        border: solid black 3px;
        border-radius: 13px;
    }

    @media screen and (max-width: 768px) {
        .lernButton {
            font-size:0.7rem;
        }
    }
    
    .Settings{
      background-color: transparent !important;
      position: fixed !important;
      top: 0.5rem !important;
      right: 0.5rem !important;
      z-index: 10000 !important;
      padding: 0.5rem !important;
      width: auto !important;
      border: none;

      :hover{
        cursor: pointer;
      }

      h1{
        margin: 0 !important;
        padding: 0 !important;
        color: black;
      }
    }

    #settings{
    width: 75vw;
    max-width: 500px;
    background-color: white !important;
    position: fixed !important;
    top: 2.5rem !important;
    right: 2rem !important;
    z-index: 99999 !important;
    padding: 1rem !important;
    border-radius: 7px !important;
    border: solid grey 1px;

    button{
      width: 100%;
      padding-top: 2px;
      padding-bottom: 2px;
      margin-top: 3px;
      margin-bottom: 3px;
      font-size:medium;
      padding-right: 3px;
      padding-left: 3px;
    }

    .buttonOn{
      background-color: green;
      color: white;
    }

    .buttonOff{
      background-color: #C00000;
      color: white;
    }

    p{
      text-align: left;
      margin: 0;
    }
  }

  hr{
      margin-top: 4px;
    }

.menuButton{
    display: flex;
    justify-content: space-between;
    span{
    margin-left: 1rem;
    margin-right: 1rem;
    font-size: large;
    }
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
    background-color: white;
    border:none;
    //border-top: solid black 1px;
    //font-weight: 300;
}

.menuButton:hover{
    background-color: rgb(223, 223, 223);
}

#menuBackground{
        width: 100vw;
        height: 100vh;
        z-index: 3;
        position: fixed;
        left: 0;
        top: 0;
    }

.aenderungsButtons{
    font-size: xx-large;
    background-color: transparent;
    border: none;
    width: auto !important;
    :hover{
        cursor:pointer;
    }
}

.buttonDelete{
  margin-left: 0.2rem;
}
}    
</style>